/* global Sys, Core */
Sys.ns("Core");

/**
 * The Settings Manager module.
 *
 * The settings manager serves as an interface for all settings values so that you do not need to know who uses it when
 * you want to modify it and who has the value when you want to read it. All is gathered in one place accessible by all.
 *
 * @class Core.SettingsManager
 * @extends Core.Module
 */
Core.SettingsManager = {

    constructor: function() {
        Core.SettingsManager.superclass.constructor.apply(this, arguments);
    },

    /**
     * @protected
     * @inheritdoc
     */
    getMixinDependencies: function() {
        return [
            "trigger"
        ];
    },

    /**
     * @protected
     * @inheritdoc
     */
    getDefaultMVCClasses: function() {
        return {
            model: Core.SettingsManagerModel,
            controller: Core.SettingsManagerController
        };
    }
};

Core.SettingsManager = Sys.extend(Core.Module, Core.SettingsManager, "Core.SettingsManager");
